var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showText || !_vm.edit
    ? _c(
        "div",
        {
          staticStyle: { width: "100%", height: "100%" },
          on: { click: _vm.onTextClick }
        },
        [_c("span", [_vm._v(_vm._s(_vm.text) + " ")])]
      )
    : _c(
        "el-select",
        {
          ref: "elSelect",
          attrs: {
            value:
              (_vm.optionField.type === "number"
                ? Number(_vm.value)
                : _vm.value) || "",
            filterable: _vm.filterable,
            remote: _vm.filterable,
            placeholder: _vm.$t("CargoMsg.Cargo_keyWordsTip"),
            "remote-method": _vm.remoteMethod,
            loading: _vm.loading,
            clearable: _vm.clearable,
            "automatic-dropdown": "",
            "default-first-option": ""
          },
          on: {
            blur: _vm.onSelectBlur,
            change: _vm.onChange,
            "visible-change": _vm.onVisibleChange
          }
        },
        _vm._l(_vm.options, function(item) {
          return _c("el-option", {
            key: item.value,
            attrs: {
              label: _vm.optionField.labelFunc
                ? _vm.optionField.labelFunc(item)
                : item[_vm.optionField.label],
              value: item[_vm.optionField.value]
            }
          })
        }),
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }